import { render } from "./TransSlide.vue?vue&type=template&id=bcf4022e&scoped=true&ts=true"
import script from "./TransSlide.vue?vue&type=script&lang=ts"
export * from "./TransSlide.vue?vue&type=script&lang=ts"

import "./TransSlide.vue?vue&type=style&index=0&id=bcf4022e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf4022e"]])

export default __exports__